import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import PurchaseFormErrorMessage from '../../common/forms/PurchaseFormErrorMessage';

type InnerProps = InjectedIntlProps;

export enum ErrorType {
  Blank = 'blank',
  Failed = 'failed',
  Taken = 'taken',
  Invalid = 'invalid',
}

const BlankMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.login.blank`,
      defaultMessage: intl.formatMessage({ id: 'purchases.errors.blank' }),
    })}
  </PurchaseFormErrorMessage>
);

const FailedMessage: React.SFC<InnerProps> = ({ intl }) => (
  <PurchaseFormErrorMessage>
    {intl.formatMessage({
      id: `purchases.errors.login.failed`,
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.failed',
      }),
    })}
  </PurchaseFormErrorMessage>
);

const ERROR_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [error in ErrorType]: React.ComponentClass | undefined;
} = {
  [ErrorType.Blank]: injectIntl(BlankMessage),
  [ErrorType.Taken]: undefined,
  [ErrorType.Invalid]: undefined,
  [ErrorType.Failed]: injectIntl(FailedMessage),
};

interface Props {
  errors?: ErrorType[];
}

class ErrorMessage extends React.Component<Props> {
  public render() {
    const { errors } = this.props;
    if (!errors) {
      return null;
    }
    if (errors.length === 0) {
      return null;
    }
    return errors.map((error, index) => {
      const Component = ERROR_COMPONENTS[error];
      if (!Component) {
        return null;
      }
      return <Component key={index} />;
    });
  }
}

export default ErrorMessage;
